import { VehicleDetails } from './view';

export { default as VehicleDetailsReducer } from './reducer';
export { default as VehicleDetailsSaga } from './saga';

export { userCarFetch } from './action';
export { selectVehicleDetails } from './selector';

export default VehicleDetails;
